import { pzApiUsersDetailsDef } from './usersDetailsApiDefs'

export const pzApiUsersDef = {
  details: pzApiUsersDetailsDef
}
